import type { FormField } from '@cli-types/core-engine/schema.js'
import { isSupportedFormFieldType } from './is-supported-form-field-type.js'
import { unsupportedFormFieldTypeMessage } from './unsupported-form-field-type-message.js'

export function assertSupportedFormFieldType(field: FormField): void {
  if (isSupportedFormFieldType(field)) return
  throw new Error(unsupportedFormFieldTypeMessage(field))
}
